<template>
	<div class="panel_shouyin">
		<div
			style="position: absolute;z-index: 2;background-color: #FEF7F2;width:100%;font-size: 12px;padding:6px 10px;color:#F5882A;top:0;">
			<img style="width:15px;vertical-align: text-bottom;" src="../../../../assets/img/mendian/tongzhi.png" />
			七天内新到宠物:{{ $public.jia(numOf7.mao, numOf7.quan) }}；猫:{{ numOf7.mao }} 犬:{{ numOf7.quan }}
		</div>
		<div class="titleLine">
			<el-row>
				<el-col :span="6">

				</el-col>
				<el-col :span="6">

				</el-col>
				<el-col :span="2" :offset="22">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<div class="L">
				<div class="label" style="padding-top:12px">已预订的宠物信息</div>
				<div>
					<span>{{ dingjinOrder.order_item_list[0].goods_name }}</span>
					<span> ({{ dingjinOrder.order_item_list[0].category_info.name }})</span>
				</div>
				<div v-if="curItem._id && curItem.product.pet_id !== dingjinOrder.order_item_list[0].goods_id" class="label"
					style="padding-top:15px;">更换后的宠物信息</div>
				<div v-if="curItem._id && curItem.product.pet_id !== dingjinOrder.order_item_list[0].goods_id">
					<span>
						{{ curItem.product.inside_name }} ({{ curItem.product.breed_info.name }})
						<el-button type="text" @click="cancelChange">取消更换</el-button>
					</span>
				</div>
				<div class="label" style="padding-top:15px;">订金销售</div>
				<div>
					<span v-for="(item, index) in dingjinOrder.order_item_list[0].sales_list"
						:key="index">{{ item.sales_name }} </span>
				</div>
				<div class="label" style="padding-top:15px;">活体销售</div>
				<div>
					<el-select v-model="saleManIdList" @change="changeSaleManIdList" :disabled="staffLock" filterable
						placeholder="请选择" size="mini" style="width:143px;">
						<el-option-group v-for="group in staffList" :key="group.value" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label"
								:value="item.value + ',' + item.label"></el-option>
						</el-option-group>
					</el-select>
					<!-- <el-select v-model="saleManIdList" @change="changeSaleManIdList" :disabled="staffLock" filterable placeholder="请选择" size="mini" style="width:143px;">
						<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item._id+','+item.basic_info.nick_name"></el-option>
					</el-select> -->
				</div>
				<div class="label">百天医疗</div>
        <el-radio-group v-model="pet_buy_item" @change="handleChange(pet_buy_item)">
          <el-radio :disabled="flag" label="2">百天</el-radio>
          <el-radio label="1">裸宠</el-radio>
        </el-radio-group>
				<div class="label" style="padding-top:15px;">活动</div>
				<el-select v-model="activityId"
					:disabled="$public.isNull(curItem._id) || !$public.isNull(curDiscountCard) || curItem.product.special_type == 1"
					@change="changeActivityId" placeholder="请选择" size="mini" style="width:120px;" clearable>
					<el-option v-for="item in activityList" :key="item._id" :label="item.name"
						:disabled="!calcPetActivity(item, addParams.curItem).state"
					
						:value="item._id"></el-option>
							<!-- :disabled="!calcPetActivity(item, addParams.curItem).state || !item.isCan" -->
				</el-select>
				<div v-if="giftTableData.length > 0" @click="openGift"
					style="font-size: 12px;margin-left:5px;color:#1890FF;display: inline-block;">
					赠品
				</div>
				<div class="label" style="padding-top:15px;">客户总订金</div>
				<div>
					{{ totalDingjinMoney }}元 <img src="../../../../assets/img/icon_eye.jpg"
						style="width:25px;margin-left:5px;vertical-align: middle;cursor: pointer;"
						@click="openDingjinOrderList" />
				</div>
				<!-- <div class="label">配套服务</div>
				<el-select v-model="serviceManIdList" @change="changeServiceManIdList" multiple filterable placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
					<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
					:value="item._id+','+item.basic_info.nick_name"></el-option>
				</el-select> -->
			</div>
			<div class="R">
				<!-- <el-row style="padding-bottom:10px;position: absolute;width:100%;background-color: #fff;z-index: 1;">
						门店
						<el-select v-model="shop" @change="changeShop" placeholder="请选择" size="mini" clearable style="width:150px">
							<el-option v-for="(item,index) in shopList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-col>
					<el-col :span="6">
						活动促销
						<el-select v-model="hasActivity" @change="changeHasActivity" placeholder="请选择" size="mini" clearable style="width:150px">
							<el-option v-for="(item,index) in [{label:'不限',value:-1},{label:'是',value:1},{label:'否',value:2}]" :key="index" :label="item.label"
							:value="item.value"></el-option>
						</el-select>
					</el-col>
				</el-row> -->
				<el-row
					style="padding:0 0 10px 12px;position: absolute;width:100%;background-color: #fff;z-index: 1;box-sizing: border-box;font-size: 12px;">
					<el-col :span="5">
						<el-input v-model="keyword" size="mini" style="width:100px;margin-right: 4px;" clearable
							@keyup.enter.native="clickSearch" placeholder="请输入"></el-input>
						<el-button size="mini" type="warning" @click="clickSearch">搜索</el-button>
					</el-col>
					<el-col :span="7">
						价格区间
						<span class="price">
							<el-input v-model="minPrice" size="mini" style="width:50px;margin-right: 4px;"
								@input="changeMinPrice"></el-input>-
							<el-input v-model="maxPrice" size="mini" style="width:50px;margin-right: 6px;"
								@input="changeMaxPrice"></el-input>
							<el-button size="mini" type="warning" @click="clickSearchPrice">搜索</el-button>
						</span>
					</el-col>
					<el-col :span="4" style="display: flex; align-items: center">
						门店
						<el-select v-model="shop" @change="changeShop" placeholder="请选择" size="mini" clearable
							style="width:100px">
							<el-option v-for="(item, indexShop) in shopList" :key="indexShop" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-col>
					<el-col :span="4">
						活动促销
						<el-select v-model="hasActivity" @change="changeHasActivity" placeholder="请选择" size="mini" clearable
							style="width:75px">
							<el-option
								v-for="(item, indexActivity) in [{ label: '不限', value: -1 }, { label: '是', value: 1 }, { label: '否', value: 2 }]"
								:key="indexActivity" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-col>
					<el-col :span="4" style="display: flex; align-items: center">
						特价
						<el-select v-model="hasSpecial" @change="changeHasSpecial" placeholder="请选择" size="mini" clearable
							style="width:75px">
							<el-option
								v-for="(item, indexSpecial) in [{ label: '不限', value: -1 }, { label: '是', value: 1 }, { label: '否', value: 0 }]"
								:key="indexSpecial" :label="item.label" :value="item.value"></el-option>
						</el-select>
						<div class="screenBtn" @click="openLivingScreen">筛选</div>
					</el-col>
					<!-- <el-col :span="4" style="display: flex; align-items: center">
						<div class="screenBtn" @click="openLivingScreen">
							筛选
						</div>
					</el-col> -->
				</el-row>
				<div class="list">
					<div class="item" :class="[curItem.product.pet_id === item.product.pet_id ? 'active' : '']"
						@click="changeItem(item)" v-for="(item, index) in tableData" :key="index">

						<!-- <div v-if="item.product.special_type == 1" class="Tejia">特价</div>

						<div class="Activity" v-if="item.product.special_type != 1 && item.activity_list">
							<div v-for="(itema, index) in item.activity_list" :key="index" class="activityy">
								<el-popover placement="top-start" title="" width="200" trigger="hover" content="">
									<div>
										<p>
											<span>活动价格：</span>
											<span style="color: #f5882a">￥{{ itema.activity_price }} </span>
										</p>
										<p>
											<span>剩余时间：</span>
											<span style="font-size: 10px;">{{
												Ftime(itema.exprice_time)
											}}</span>
										</p>
										<p>
											<span>活动说明：<br /></span>
											<span style="font-size: 10px;">{{ itema.remark }}</span>
										</p>
									</div>
									<div slot="reference" class="activity">
										{{ itema.name.slice(0, 4) }}
									</div>
								</el-popover>
							</div>
						</div> -->
						<!-- <img v-if="item.product.create_day<8" class="markerImg2" style="left:0;top:-8px;width:30px;height:30px;" src="../../../../assets/img/mendian/newHuoti.png" /> -->
						<img v-if="config_content.indexOf(item.product.eprom_no) != -1" class="markerImg3"
							style="left:0px;top:0px;width:50px;height:50px;" src="../../../../assets/img/baokuan.png" />

						<div class="reservedBox" v-if="item.product.sale_status && item.product.sale_status.value === '2'">
							<!-- 死亡(-1) 异常(0) 正常(1)  锁定(2) 转移中(3) 销售(9) -->
							<img style="width:110px;margin-bottom:20px;" src="../../../../assets/img/reserved.png" />
							<div>
								预定计时：
								<livingCountDown :stamp="item.product.book_time" @stop="stopCountDown"></livingCountDown>
							</div>
						</div>
						<div class="picture"><img
								:src="item.product.cover + '?x-oss-process=image/resize,w_320,h_320,m_lfit'" /></div>

						<!-- s<img v-if="curItem.product.pet_id===item.product.pet_id" class="markerImg2" src="../../../../assets/img/mendian/huotiSelected.png" /> -->
						<!-- <img v-else class="markerImg2" src="../../../../assets/img/bottomRightNoChecked.png" /> -->
						<div class="line">
							<span class="lineL" style="width:109px;">
								{{ item.product.inside_name }}
								<!-- | {{item.product.category_info.name}} --><!-- 刘总ding -->
							</span>
							<span style="width:45px;text-align: right;">
								<!-- {{$public.FAge(item.product.bron_date)[0]>0?$public.FAge(item.product.bron_date)[0]+'岁':''}}{{$public.FAge(item.product.bron_date)[1]}}月 -->
								{{ item.product.pet_age }}
							</span>
							<span
								v-if="item.product.last_sale_price !== 0 && item.price != item.product.last_sale_price && item.product.special_type != 1">
								<el-popover placement="top-start" title="" width="10" trigger="hover" content="">
									<p>调价前 <span style="color: #F5882A;">￥{{ item.product.last_sale_price }}</span> </p>
									<div slot="reference" class="activity" v-if="item.price > item.product.last_sale_price">
										<img src="../../../../assets/img/mendian/up.png" alt=""
											style="width: 25px;height: 15px;"> </div>
									<div slot="reference" class="activity" v-if="item.price < item.product.last_sale_price">
										<img src="../../../../assets/img/mendian/down.png" alt=""
											style="width: 25px;height: 15px;"> </div>
								</el-popover>
							</span>
						</div>
						<div class="line" style="justify-content: flex-start;flex-wrap: wrap;">
							{{ item.product.apply_type.title }} | {{ item.product.pet_sex }} | {{ item.product.pet_color }} |
							{{ item.vaccine_complete_count > 0 ? $public.formatNumTochinese(item.vaccine_complete_count) + '针| ':''}}
							{{ item.product.custom_features[0] ? item.product.custom_features[0] : '' }}
							{{ item.product.custom_features[1] ? item.product.custom_features[1] : '' }}
							{{ item.product.custom_features[2] ? item.product.custom_features[2] : '' }}
							{{ item.product.custom_features[3] ? item.product.custom_features[3] : '' }}
							{{ item.product.custom_features[4] ? item.product.custom_features[4] : '' }}
							{{ item.product.custom_features[5] ? item.product.custom_features[5] : '' }}
							{{ item.product.custom_features[6] ? item.product.custom_features[6] : '' }}
							{{ item.product.custom_features[7] ? item.product.custom_features[7] : '' }}
							{{ item.product.custom_features[8] ? item.product.custom_features[8] : '' }}
							{{ item.product.custom_features[9] ? item.product.custom_features[9] : '' }}
						</div>
						<div class="line">
							<span class="lineL">芯片：{{ item.product.eprom_no }}</span>
						</div>
						<div class="line">
							<span class="lineL">编号：{{ item.product.inside_no }}</span>
						</div>
						<div class="line" v-if="item.product.create_day < 7">
							<span v-if="item.product.create_day === 0" class="lineL"
								style="color:rgb(245, 136, 42);">今日到店</span>
							<span v-else class="lineL"
								style="color:rgb(245, 136, 42);">{{ item.product.create_day }}天前到店......</span>
						</div>
						<div class="priceLine" style="display: flex;justify-content: space-between;align-items: center;">
							<el-popover trigger="hover" placement="bottom-start">
                <p style="font-size: 12px">裸宠价：{{ item.product.discount_price }}</p>
                <p style="font-size: 12px">百天差价：{{ item.product.differ_price }}</p>
              <!-- 没活动和特价显示的原价 -->
              <span slot="reference" class="price" v-if="item.activity_price < 0 && item.product.special_type !== 1">￥{{
        item.price }}</span>
              <!-- 有活动的 原价 -->
              <div slot="reference" v-if="item.activity_price > 0" class="price">￥{{ item.price }}</div>
              <!-- 活动价 -->
              <!-- 特价 -->
              <span  slot="reference" class="price" v-if="item.product.special_type == 1">￥{{ item.product.price }}</span>
            </el-popover>
							<span>{{ $public.getShopNameById(item.product.feed_shop) }}</span>
						</div>
					</div>
				</div>
				<div class="pageLine">
					<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
				</div>
			</div>
		</div>
		<!-- 赠品 -->
		<div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div>
		<!-- 筛选 -->
		<div v-if="drawerLivingScreen_state">
			<livingScreen :petClass="petClass" :petSex="petSex" :petType="petType" :petColor="petColor"
				:petFeatures="petFeatures" :petNeedleNumber="petNeedleNumber" :petAge="petAge" :addDay="addDay"
				@submit="submit_drawerLivingScreen"></livingScreen>
		</div>
		<div v-if="drawerDingjinOrderList_state">
			<drawerDingjinOrderList :type="'see'" @submit="submit_drawerDingjinOrderList"></drawerDingjinOrderList>
		</div>
	</div>
</template>
<script>
import page from "../../../../components/page.vue"
import setGift from "../../../../components/drawer/setGift.vue"
import livingScreen from "../drawer/livingScreen.vue"
import livingCountDown from "./living_countdown.vue"
import drawerDingjinOrderList from "../drawer/dingjinOrderList.vue"
export default {
	components: { page, setGift, livingScreen, livingCountDown, drawerDingjinOrderList },
	data() {
		return {
			// 筛选
			keyword: '',
			minPrice: '',
			maxPrice: '',
			shop: '',
			hasActivity: -1,
			hasSpecial: -1,
			petClass: '0',
			petSex: '0',
			petType: [''],
			petColor: ['全部'],
			petFeatures: ['全部'],
			petNeedleNumber: ['全部'],
			petAge: ['0,0'],
			addDay: 0,
			drawerLivingScreen_state: false,
			config_content: [], //爆款宠物
			// 活体列表
			tableData: [],
			page: {
				page: 1,
				pageSize: 48,
				total: 0
			},
			// 客户总订金
			totalDingjinMoney: 0,

			curItem: { product: { custom_no: '', petId: '', eprom_no: '' } },
			// 销售人员
			saleManIdList: '',
			staffLock: false,
			staffList: [],
			// 活动
			activityId: '',
			activityList: [],
			// 赠品
			drawerGift_state: false,
			giveGoods: {},
			giftTableData: [],

			// 订金订单列表
			drawerDingjinOrderList_state: false,
			// 7天内的活体数量
			numOf7: {},
			pet_buy_item: '2',
			flag:false
		}
	},
	computed: {
		userInfo() {
			if (this.$store.state.mendian.userInfo._id) {
				return this.$store.state.mendian.userInfo;
			} else {
				return {
					basic_info: {},
					card_info: {},
					company_info: {},
					operation_info: {},
					pets_info: [],
					club_card: {}
				}
			}
		},
		curPetId() {
			return this.$store.state.mendian.curPetId;
		},
		curPetInfo() {
			return this.$store.getters['mendian/curPetInfo'];
		},
		shopList() {
			return this.$store.getters['shopList']
		},
		addParams() {
			return this.$store.state.livingUpdate.addParams;
		},
		money() {
			return this.$store.state.livingUpdate.money;
		},
		activityMoney() {
			return this.$store.state.livingUpdate.activityMoney;
		},
		curDiscountCard() {
			return this.$store.state.livingUpdate.curDiscountCard;
		},
		dingjinOrder() {
			return this.$store.state.livingUpdate.dingjinOrder;
		},
		dingjinOrderList() {
			return this.$store.state.mendian.dingjinOrder;
		},
		refresh() {
			return this.$store.state.living.refresh;
		},
		Ftime() {
			return (time) => {
				const date1 = Math.round(new Date().getTime() / 1000).toString(); //开始时间
				const date2 = time; //结束时间
				const date3 = date2 - date1; //时间差的毫秒数
				if (date3 < 0) {
					return "活动已结束"
				} else {
					//计算出相差天数
					const days = Math.floor(date3 / 60 / 60 / 24);
					//计算出小时数
					const leave1 = (date3 / 60 / 60); //计算天数后剩余的毫秒数
					const hours = Math.floor(leave1 - 24 * days)
					//计算相差分钟数
					const leave2 = date3 / 60; //计算小时数后剩余的毫秒数 59040
					const minutes = Math.floor(leave2 - ((24 * 60 * days) + (60 * hours)));
					if (days >= 1) {
						const datetime =
							days + "天 ";
						return datetime;
					} if (days < 1) {
						const datetime =
							hours + "小时 ";
						return datetime;
					} if (hours < 1) {
						const datetime =
							minutes + "分钟 ";
						return datetime;
					}

					//计算相差秒数
					const seconds = Math.round(date3 - ((24 * 60 * 60 * days) + (60 * 60 * hours) + (60 * minutes)));

				}

			};
		},
	},
	watch: {
		refresh() {
			this.saleManIdList = '';
			this.changeSaleManIdList();
			this.activityId = '';
			this.changeActivityId();
			this.curItem = { product: { custom_no: '', petId: '', eprom_no: '' } };
			this.changeItem();
			this.getList();
		}
	},
	mounted() {
		for (let i = 0; i < this.dingjinOrderList.length; i++) {
			this.totalDingjinMoney = this.$public.jia(this.totalDingjinMoney, this.dingjinOrderList[i].order_item_list[0].price)
		}
		this.getList();
		this.getStaffList();
		this.getNumOf7()
		this.getSingle()
		this.$http.get(process.env.VUE_APP_Url6 + 'api/Activity/GetPetRelevance', { pet_id: this.dingjinOrder.order_item_list[0].goods_id }).then(res => {
			if (res.code == 0) {
				this.changeItem(res.data)
			}
		})
		this.$store.state.mendian.userController.map((controller) => {
			if (controller.invitationType === 4 && controller.userId.length > 0) {
				this.saleManIdList = controller.userId + "," + controller.userName
				this.staffLock = controller.lock
			}
		})
		this.addParams.saleManIdList = this.saleManIdList
		this.$store.commit('livingUpdate/set_addParams', this.addParams)
	},
	methods: {
		calcPetActivity(ctivityItem, curItem) {
      if ((this.pet_buy_item == 1 && ctivityItem.pet_buy_item == 2) || (this.pet_buy_item == 2 && ctivityItem.pet_buy_item == 1)) {
        return {
          state: false,
          type: "none",
          limit: 0,
          gift: {},
          newPrice: 0,
        };
      }
      if (this.pet_buy_item == 1) {
        return this.$public.calcActivity(ctivityItem, curItem.product.discount_price, 1)

      } else {
        return this.$public.calcActivity(ctivityItem, curItem.price, 1)
      }
    },
		back() {
			this.$store.commit('mendian/set_curBusiness', '活体')
			this.$store.commit('living/set_type', 'dingList')
		},
		// 取消更换
		cancelChange() {
			console.log(this.dingjinOrder)
			let item = {}
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].product.pet_id === this.dingjinOrder.order_item_list[0].goods_id) {
					item = this.tableData[i]
				}
			}
			console.log(item)
			this.changeItem(item)
		},
		// 关键字
		clickSearch() {
			this.page.page = 1;
			this.getList();
		},
		// 价格区间
		changeMinPrice() {
			this.minPrice = this.$public.replaceGoodsDosage(this.minPrice)
		},
		changeMaxPrice() {
			this.maxPrice = this.$public.replaceGoodsDosage(this.maxPrice)
		},
		clickSearchPrice() {
			this.page.page = 1;
			this.getList();
		},
		changeShop() {
			this.page.page = 1;
			this.getList();
		},
		changeHasActivity() {
			this.page.page = 1;
			this.getList();
		},
		changeHasSpecial() {
			this.page.page = 1;
			this.getList();
		},
		changeItem(row) {
			if (row.product.sale_status && row.product.sale_status.value === '2' && this.dingjinOrder.order_item_list[0].goods_id !== row.product.pet_id) {
				this.$message({
					message: '该宠物已被预定',
					type: 'error'
				});
				return;
			}
		  if(this.curItem.product.special_type==1){
        this.pet_buy_item = '1'
        this.flag=true
      }else{
        this.pet_buy_item = '2'
        this.flag=false
      }
			this.activityId = '';
			this.activityList = row.activity_list;
			this.curItem = row;
			this.addParams.curItem = this.curItem;
			this.$store.commit('livingUpdate/set_addParams', this.addParams)
			this.$store.commit("livingUpdate/set_pet_buy_item", this.pet_buy_item);
			this.$store.commit('livingUpdate/set_money', row.price)
			this.$store.commit('livingUpdate/set_activityMoney', row.price)
		},
		changePage(num) {
			this.page.page = num;
			this.getList()
		},
		getList() {
			if (!this.$public.isNull(this.minPrice) && this.$public.isNull(this.maxPrice)) {
				this.$message({
					message: '区间最大值输入有误！',
					type: 'error'
				});
				return;
			}
			if (!this.$public.isNull(this.maxPrice) && this.$public.isNull(this.minPrice)) {
				this.$message({
					message: '区间最小值输入有误',
					type: 'error'
				});
				return;
			}
			let petClass = [];
			if (this.petClass === '0') {
				petClass = []
			} else if (this.petClass === '1') {
				petClass = ['1']
			} else if (this.petClass === '2') {
				petClass = ['2']
			}
			let petSex = [];
			if (this.petSex === '0') {
				petSex = []
			} else if (this.petSex === '1') {
				petSex = ['公']
			} else if (this.petSex === '2') {
				petSex = ['母']
			}
			let min_month = 10000;
			let max_month = 0;
			for (let i = 0; i < this.petAge.length; i++) {
				let month = this.petAge[i].split(',')
				if (min_month > month[0]) {
					min_month = month[0]
				}
				if (max_month < month[1]) {
					max_month = month[1]
				}
			}
			let hs_master = 0;
			if (this.userInfo.pet_count && this.userInfo.pet_count.hsTotal > 0) {
				hs_master = 1
			} else if (this.userInfo.pet_count && this.userInfo.pet_count.hsTotal == 0) {
				hs_master = 2
			}
			let activity_user = 0
			if (this.userInfo.club_card && this.userInfo.club_card. surplus_day < 1) {
				activity_user = 1
			} else if (this.userInfo.club_card && this.userInfo.club_card. surplus_day >= 1) {
				activity_user = 2
			}
			let add_day = this.addDay
			let params = {
				category: this.petType[0] === '' ? [] : this.petType,
				min_month: Number(min_month),
				max_month: Number(max_month),
				vaccine_complete_count: this.petNeedleNumber[0] === '全部' ? [] : this.petNeedleNumber, // 完成计划数量
				apply_type: petClass, // 1:猫 2:犬
				pet_state: ['1', '2'], // 1 可出售 2 锁定
				pet_sex: petSex, // 宠物的性别 公 母
				custom_features: this.petFeatures[0] === '全部' ? [] : this.petFeatures, // 宠物特征
				pet_color: this.petColor[0] === '全部' ? [] : this.petColor, // 宠物颜色
				order_type: -1, // 排序类型 -1 上架时间 1 价格 2 月份
				order_asc: 2, // 正序倒叙 1 正序 2 倒叙

				"page_index": this.page.page,
				"page_size": this.page.pageSize,
				"keyword": this.keyword,
				"shop_id": this.shop,
				"is_activity": this.$public.isNull(this.hasActivity) ? -1 : this.hasActivity,  // -1 不限 1 参与活动 2 不参与活动
				special_type: this.$public.isNull(this.hasSpecial) ? -1 : this.hasSpecial,  //-1 不限 1 特价 0 无特价
				pet_level: this.level,// 宠物星级
				min_price: this.minPrice ? Number(this.minPrice) : 0,
				max_price: this.maxPrice ? Number(this.maxPrice) : 0,
				add_day: add_day,
				hs_master: hs_master,
				new_member: this.userInfo.isnew_member,
				staff_type: this.userInfo.staff_type, // 1在职  2.离职
				user_id: this.userInfo._id,
				vipCardUser: this.userInfo.club_card.is_valid,
				activity_user: activity_user, //1普通 2充值
			}
			let loading = this.$loading();
			this.$http.post(process.env.VUE_APP_Url6 + 'api/Activity/GetPetRelevanceList', params).then(res => {
				loading.close();
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.page.total = res.data.count;
				}
			})
		},
		handleChange(pet_buy_item) {
      this.pet_buy_item = pet_buy_item
      this.$store.commit("livingUpdate/set_pet_buy_item", this.pet_buy_item);
      this.activityId = ''
      this.$store.commit("livingUpdate/set_addParams", this.addParams);
      if (pet_buy_item == 1) {
				console.log(this.addParams.curItem.product.discount_price,'this.addParams.curItem.product.discount_price1');
        let price = this.addParams.curItem.product.discount_price
        this.$store.commit("livingUpdate/set_activityMoney", price);
        this.$store.commit("livingUpdate/set_money", price);
      } else {
        let price = this.addParams.curItem.price
        this.$store.commit("livingUpdate/set_activityMoney", price);
        this.$store.commit("livingUpdate/set_money", price);
      }
      this.$store.commit("livingUpdate/set_pet_buy_item", this.pet_buy_item);
    },
		// 活动
		changeActivityId() {
			this.addParams.activityId = this.activityId
			this.addParams.activityItem = this.$public.getMatchingItem(this.activityList, "_id", this.activityId)
			this.$store.commit('livingUpdate/set_addParams', this.addParams)
			if (this.$public.isNull(this.addParams.activityId)) {
				this.$store.commit('livingUpdate/set_activityMoney', this.money)
			} else {
				let calcResult = this.calcPetActivity(
          this.addParams.activityItem,
          this.addParams.curItem,
          1
        );
				this.$store.commit('livingUpdate/set_activityMoney', calcResult.newPrice)
				if (!this.$public.isNull(calcResult.gift.give_list)) {
					this.giveGoods = calcResult.gift;
					this.drawerGift_state = true;
				}
			}
		},
		// 赠品
		openGift() {
			this.giveGoods.giftTableData = JSON.parse(JSON.stringify(this.giftTableData))
			this.drawerGift_state = true
		},
		submit_drawerGift({ giftTableData }) {
			this.giftTableData = giftTableData
			this.drawerGift_state = false;
			this.addParams.giftTableData = this.giftTableData
			this.$store.commit('livingUpdate/set_addParams', this.addParams)
		},
		// 销售人员
		changeSaleManIdList() {
			this.addParams.saleManIdList = this.saleManIdList
			this.$store.commit('livingUpdate/set_addParams', this.addParams)
		},
		getStaffList() {
			let params = {
				"keyword": '',
				"pageIndex": 1,
				"pageSize": 1000,
			}
			this.$http.get('/api/Staff/AllList', params).then(res => {
				if (res.code == 0) {
					this.staffList = [];
					let arr = [{}]
					for (let i = 0; i < this.shopList.length; i++) {
						if (this.shopList[i].value === this.$store.state.shopId) {
							arr[0] = { label: this.shopList[i].label, value: this.shopList[i].value, options: [] }
						} else {
							arr.push({ label: this.shopList[i].label, value: this.shopList[i].value, options: [] })
						}
					}
					for (let i = 0; i < res.data.data.length; i++) {
						let item = res.data.data[i]
						for (let a = 0; a < arr.length; a++) {
							if (item.shopId === arr[a].value) {
								arr[a].options.push({ label: item.basic_info.nick_name, value: item._id })
							}
						}
					}
					this.staffList = arr;
				}
			})
			// let params = {
			// 	"keyword": '',
			// 	"pageIndex": 1,
			// 	"pageSize": 500,
			// }
			// this.$http.get('/api/Staff/List', params).then(res => {
			// 	if (res.code == 0) {
			// 		this.staffList = res.data.data;
			// 	}
			// })
		},
		stopCountDown() {
			this.getList();
		},
		// 筛选
		openLivingScreen() {
			this.drawerLivingScreen_state = true;
		},
		submit_drawerLivingScreen(obj) {
			this.drawerLivingScreen_state = false;
			if (obj.type === 'success') {
				this.petClass = obj.data.petClass;
				this.petSex = obj.data.petSex;
				this.petType = obj.data.petType;
				this.petColor = obj.data.petColor;
				this.petFeatures = obj.data.petFeatures;
				this.petNeedleNumber = obj.data.petNeedleNumber;
				this.petAge = obj.data.petAge;
				this.addDay = obj.data.addDay;
				this.page.page = 1;
				this.getList();
			}
		},
		// 订金列表弹窗
		openDingjinOrderList() {
			this.drawerDingjinOrderList_state = true
		},
		submit_drawerDingjinOrderList() {
			this.drawerDingjinOrderList_state = false;
		},
		getSingle() {
			let params = {
				"id": "hotpet"
			}
			this.$http.get(process.env.VUE_APP_AppAdmin + '/api/DataBase/config/single', params).then(res => {
				console.log(res, "res?????");
				this.config_content = res.data.config_content

			})
		},
		getNumOf7() {
			let loading = this.$loading();
			this.$http.get(process.env.VUE_APP_Url6 + 'api/Activity/GetPetRelevanceStatic', {}).then(res => {
				loading.close();
				if (res.code == 0) {
					this.numOf7 = res.data
				}
			})
		}
	}
}
</script>
<style scoped lang="scss">
.el-select-dropdown__item.is-disabled {
	color: #b7b7b9;
	cursor: default;
	background-color: #f9f6f6;
}

.panel_shouyin {
	height: 100%;
	padding-bottom: 60px;
	padding-top: 20px;
	box-sizing: border-box;
	position: relative;

	.titleLine {
		width: 100%;
		background-color: #fff;
		height: 44px;
		padding: 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		z-index: 1;
	}

	.con {
		display: flex;
		padding: 60px 12px 66px 12px;
		background-color: #fff;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		position: absolute;
		top: 0;

		.L {
			width: 155px;
			border-right: 1px solid #f5f5f5;
			flex-shrink: 0;
			box-sizing: border-box;

			.label {
				font-size: 12px;
				padding-bottom: 10px;
			}

			.xmjBox {
				.xmjItem {
					position: relative;
					width: 123px;
					box-sizing: border-box;
					height: 40px;
					text-align: center;
					line-height: 38px;
					color: #000;
					font-size: 14px;
					background-color: #E8E8E8;
					border-radius: 2px;
					margin-top: 15px;
					margin-left: 20px;
					border: 1px solid transparent;
					cursor: pointer;

					&.active {
						background-color: #E3F2FF;
						border-color: #1890FF;
					}

					.checked {
						position: absolute;
						right: 0;
						bottom: 0;
						width: 26px;
						height: 13px;
						text-align: center;
						color: #fff;
					}
				}
			}
		}

		.R {
			width: 100%;
			height: 100%;
			position: relative;

			&::-webkit-scrollbar {
				width: 4px;
				// height: 4px;
			}

			.price {
				::v-deep .el-input__inner {
					padding: 0 5px;
				}
			}

			.screenBtn {
				width: 60px;
				height: 28px;
				border-radius: 2px;
				text-align: center;
				line-height: 28px;
				color: #999;
				cursor: pointer;
				border: 1px solid rgba(0, 0, 0, 0.15);
			}

			.list {
				margin: 0 12px;
				padding: 40px 0 60px;
				height: 100%;
				box-sizing: border-box;
				overflow: auto;

				.item {
					display: inline-block;
					width: 174px;
					height: 320px;
					border-radius: 4px;
					overflow: hidden;
					border: 2px solid rgba(151, 151, 151, 0.25);
					position: relative;
					margin: 0px 6px 6px;

					// 标签
					.Activity {
						color: #f5efef;
						position: absolute;
						top: 0;
						right: 0;

						.activityy {
							font-size: 10px;
							width: 50px;
							height: 21px;
							font-size: 10px;
							text-align: center;
							background-color: #fe2d2d;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							line-height: 21px;
							border-radius: 0px 4px 0px 4px;
						}
					}

					.Tejia {
						width: 46px;
						height: 21px;
						font-size: 10px;
						position: absolute;
						top: 0;
						right: 0;
						text-align: center;
						background-color: #0e7cfb;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #ffffff;
						line-height: 21px;
						border-radius: 0px 4px 0px 4px;
					}

					cursor: pointer;
					box-sizing: border-box;

					&.active {
						border-color: $mainColor;
						background-color: rgba(245, 136, 42, 0.06);
					}

					.reservedBox {
						width: 100%;
						height: 100%;
						position: absolute;
						padding-top: 65px;
						box-sizing: border-box;
						font-size: 16px;
						text-align: center;
						color: #fff;
						background-color: rgba(0, 0, 0, 0.4);
					}

					.picture {
						width: 100%;
						height: 140px;

						img {
							width: 100%;
							height: 100%;
							//   object-fit: cover;
						}
					}

					.markerImg1 {
						width: 120px;
					}

					.markerImg2 {
						width: 20px;
						height: 20px;
						position: absolute;
						top: 6px;
						right: 6px;
					}

					.markerImg3 {
						width: 20px;
						height: 20px;
						position: absolute;
						bottom: 6px;
						right: 6px;
					}

					.line {
						width: 100%;
						font-size: 12px;
						color: $fontColor;
						display: flex;
						justify-content: space-between;
						padding: 10px 8px 0;
						box-sizing: border-box;

						.lineL {}

						.lineR {}
					}

					.priceLine {
						padding: 10px 8px 5px;
						font-size: 12px;
						color: $fontColor;

						.price {
							font-size: 18px;
							color: #ff4646;
						}
					}
				}
			}

			.pageLine {
				position: absolute;
				width: 100%;
				background-color: #fff;
				bottom: 0;

				::v-deep .paging {
					margin-top: 10px;
					padding-bottom: 10px;
				}
			}
		}
	}
}</style>
